import styled from "styled-components";

export const Container = styled.div`
    display:flex;
    flex-direction:column;
    align-items:flex-end;

    button {
        margin-top: 10px;
    }


    @media (min-width: 576px) {
        flex-direction:row;
        
        button {
            margin-top: 0;
            border-radius: 0;

            &:first-child{
                border-radius: 25px 0 0 25px;
            }

            &:last-child {
                border-radius: 0 25px 25px 0;
            }

            &:only-child {
                border-radius: 25px;
            }
        }
    }
    
`;